export enum Language {
    ENGLISH = 'en',
    SPANISH = 'es',
    FRENCH = 'fr',
    PORTUGUESE = 'pt'
}